import React, { Component } from 'react';
import $ from 'jquery';
import moment from 'moment';

class ChallengesLeftMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'lifetime'
        };
        this.refreshInterval = null;
    }
    lcb = (start, end) => {
        $('.custom_date_range').val(start.format('DD-MM-YYYY') + ' - ' + end.format('DD-MM-YYYY'));
        this.props.getAttrData({
            start_date: start.format('YYYY-MM-DD'),
            end_date: end.format('YYYY-MM-DD'),
            filter_by: "custom"
        });
    }

    componentDidMount() {

        const {challengeData } = this.props;
        const challenge_start_date = challengeData.start_date
        const challenge_end_date = challengeData.end_date

        const start = moment(challenge_start_date, 'YYYY-MM-DD');
        const end = moment(challenge_end_date, 'YYYY-MM-DD');
        $('.custom_date_range').daterangepicker({
            startDate: start,
            endDate: end,
            minDate: start,
            maxDate: end,
            locale: {
                format: 'DD-MM-YYYY',
                cancelLabel: 'Clear'
            }
        }, this.lcb);
    }


    handleWeekClick = (weekNumber) => {
        this.setState({ activeTab: weekNumber });
        this.props.onWeekChange(weekNumber);
        if (this.props.stopChallengeLoading) {
            this.props.stopChallengeLoading();
        }
    };

    handleLifetimeClick = () => {
        this.setState({ activeTab: 'lifetime' });

        this.props.onWeekChange('lifetime');
        if (this.props.stopChallengeLoading) {
            this.props.stopChallengeLoading();
        }
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        return `${day} ${month}`;
    };

    XdayClick = () => {
        const left_menu_x_day = document.getElementById("x_day_from_start").value;
        if ((left_menu_x_day !== '') && (left_menu_x_day > 0)) {
            this.props.getAttrData({
                filter_by: 'x_day',
                x_day: left_menu_x_day
            });
        }
    }

    render() {

        const weeks = this.props.weeks;
        const { activeTab } = this.state;
        const total_weeks = weeks.length;

        const {challengeData } = this.props;
        const challenge_start_date = challengeData.start_date
        const challenge_end_date = challengeData.end_date

        return (
            <div className="vertical_cus_tab_wrapper">
                <ul className="nav nav-tabs vertical_cus_tab" id="myTab" role="tablist">
                     <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'lifetime' ? 'active' : ''}`}
                            onClick={() => this.handleLifetimeClick('lifetime')}
                            id="lifetime-tab"
                            data-toggle="tab"
                            href="#tab_data"
                            role="tab"
                            aria-controls="Lifetime"
                            aria-selected={activeTab === 'lifetime'}
                        >
                            Lifetime ({this.formatDate(challenge_start_date)} - {this.formatDate(challenge_end_date)})
                        </a>
                    </li>
                    {Array.from({ length: total_weeks }, (_, i) => {
                        const weekNumber = i + 1;
                        const weekData = weeks[i] || {};
                        return (
                            <li className="nav-item" key={`week-${weekNumber}`}>
                                <a
                                    className={`nav-link ${activeTab === weekNumber ? 'active' : ''}`}
                                    onClick={() => this.handleWeekClick(weekNumber)}
                                    id={`week-${weekNumber}-tab`}
                                    data-toggle="tab"
                                    href="#tab_data"
                                    role="tab"
                                    aria-controls={`Week ${weekNumber}`}
                                    aria-selected={activeTab === weekNumber}
                                >
                                    <span className="week-label">
                                        Week {weekNumber}
                                        {weekData.start_date && weekData.end_date && (
                                            <> &nbsp; {this.formatDate(moment(weekData.start_date).add(1, 'days'))} - {this.formatDate(moment(weekData.end_date).add(1, 'days'))}</>
                                        )}
                                    </span>
                                </a>
                            </li>
                        );
                    })}
                   
                </ul>
                <input id="leftdatarange" type="text" className="custom_date_range report_date_range font_14 text_black fw_ar_reg date_by_day" />
                <div className="tab_search report_tab_search mt_10 d-flex align-items-center">
                    <span className="font_12 text_black fw_ar_reg d-block">Start from </span>
                    <input name="x_day_from_start" id="x_day_from_start" className="tab_rep_search font_14 text_black fw_ar_reg" placeholder="X" />
                    <span className="font_12 text_black fw_ar_reg mr_5 d-block">day(s)</span>
                    <button type="submit" className="shop_more font_12 text_white fw_ar_reg" onClick={this.XdayClick} data-toggle="tab" href="#tab_data" role="tab">
                        GO
                    </button>
                </div>
            </div>
        );
    }
}

export default ChallengesLeftMenu;
